import clsx from 'clsx';
import { Box } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Fragment, FunctionComponent } from 'react';
import SelectionBarItem from './SelectionBarItem';
import { ReactNode } from 'react';

export interface SelectionBarOption<T = string> {
    id: T;
    name: ReactNode;
    selectedBackgroundColor?: string;
}

export interface SelectionBarProps {
    options: Array<SelectionBarOption<string>>;
    selectedId: string;
    selectedTotalRecords?: number;
    background?: string;
    borderColor?: string;
    className?: string;
    onSelect: (id: string) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: (props: SelectionBarProps) => ({
            gap: 10,
            display: 'flex',
            background: props.background || '#F8F8F8',
            border: props.borderColor ? `1px solid ${props.borderColor}` : 'none',
            height: 'fit-content',
            width: 'fit-content',
            [theme.breakpoints.up('md')]: {
                gap: 14,
                paddingTop: 5,
                paddingLeft: 8,
                paddingRight: 8,
                paddingBottom: 5,
                borderRadius: 30
            }
        })
    })
);

export const SelectionBar: FunctionComponent<SelectionBarProps> = props => {
    const classes = useStyles(props);

    const renderLabel = (option: SelectionBarOption<string>) => {
        if (option.id === props.selectedId && props.selectedTotalRecords !== undefined) {
            return (
                <>
                    {option.name} ({props.selectedTotalRecords})
                </>
            );
        }
        return option.name;
    };

    const buttons = props.options.map(option => {
        return (
            <Fragment key={option.id}>
                <Box>
                    <SelectionBarItem
                        label={renderLabel(option)}
                        selected={option.id === props.selectedId}
                        onClick={() => {
                            props.onSelect(option.id);
                        }}
                        selectedBackgroundColor={option.selectedBackgroundColor}
                    />
                </Box>
            </Fragment>
        );
    });

    return <Box className={clsx(classes.container, props.className)}>{buttons}</Box>;
};

export default SelectionBar;
